import React from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { textSize, Points, marginLevel, paddingLevel } from '@styles';
import { Button } from 'planoplan-ui-kit/core/button';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { useMediaQuery } from 'planoplan-ui-kit/core/hooks/useMediaQuery';
import { CustomLink } from '@components/Custom-Link';
import { useTranslations } from '@libs/translations';

export const ErrorConnection = () => {
  const isTabletPortrait = useMediaQuery(Points.tablet_portrait, { useSSR: true });
  const translations = useTranslations();

  const router = useRouter();

  const handleRefresh = () => {
    router.reload();
  };

  return (
    <Container>
      <h1>(×_×)</h1>
      <h2>{translations.t('site.help.errorConnection')}</h2>
      <ButtonWrapper>
        <CustomLink onClick={handleRefresh}>
          <Button theme="primary" size={isTabletPortrait ? 'L' : 'S'} isMobile={deviceDetected.isMobile}>
            {translations.t('site.help.tryAgainButton')}
          </Button>
        </CustomLink>
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.section`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  margin: auto;
  margin-bottom: 50px;
  padding-left: 30px;
  padding-right: 30px;
  ${paddingLevel('both', 'colar')};

  @media ${Points.tablet_portrait} {
    padding-left: 40px;
    padding-right: 40px;
  }

  main > & {
    ${marginLevel('top', 'colar')};
  }

  h1 {
    ${marginLevel('bottom', 'dark_cream')};
    ${textSize('h1')};
    text-align: center;
  }

  h2 {
    ${marginLevel('bottom', 'dark_cream')};
    ${textSize('h3')};
    text-align: center;
  }

  a {
    text-decoration: none;
  }
`;

const ButtonWrapper = styled.div`
  min-width: 180px;
  margin: 0 auto;

  @media ${Points.tablet_portrait} {
    min-width: 280px;
  }
`;
